import { $, $$ } from '../lib/dom.js';
import { CONFIG } from '../config.js';

/* Modal de casos (imagen ampliada / tour 360° embebido).
   Usa <dialog> nativo: Escape, trampa de foco e inertización del fondo salen gratis.
   El paso de una pieza a otra sin cerrar es un agregado sobre la plantilla. */
export function initModal() {
  const modal = $('[data-modal]');
  if (!modal) return;

  const panel = $('[data-modal-panel]', modal);
  const heading = $('[data-modal-heading]', modal);
  const body = $('[data-modal-body]', modal);
  const count = $('[data-modal-count]', modal);
  const supportsDialog = typeof modal.showModal === 'function';

  const cards = $$('[data-modal-type]');
  if (!cards.length) return;
  let index = 0;

  function render(i) {
    index = (i + cards.length) % cards.length;
    const card = cards[index];
    let type = card.getAttribute('data-modal-type');
    let src = card.getAttribute('data-modal-src');
    const title = card.getAttribute('data-modal-title') || '';
    if (type === 'tour') {
      type = 'iframe';
      src = CONFIG.tourUrl;
    }

    heading.textContent = title;
    body.textContent = ''; // también detiene el iframe del tour anterior

    let node;
    if (type === 'iframe') {
      node = document.createElement('iframe');
      node.src = src;
      node.title = title;
      node.allow = 'fullscreen; gyroscope; accelerometer; xr-spatial-tracking';
      node.allowFullscreen = true;
      node.loading = 'lazy';
    } else {
      node = document.createElement('img');
      node.src = src;
      node.alt = title;
    }
    body.appendChild(node);

    if (count) count.textContent = `${index + 1} / ${cards.length}`;
  }

  function open(i) {
    render(i);
    document.body.classList.add('pv-modal-open');
    if (supportsDialog) modal.showModal();
    else modal.setAttribute('open', '');
  }

  function close() {
    if (supportsDialog && modal.open) modal.close();
    else modal.removeAttribute('open');
    cleanup();
  }

  function cleanup() {
    document.body.classList.remove('pv-modal-open');
    body.textContent = ''; // detiene el iframe del tour
  }

  const isOpen = () => (supportsDialog ? modal.open : modal.hasAttribute('open'));

  cards.forEach((card, i) => {
    card.addEventListener('click', () => open(i));
  });

  $$('[data-modal-close]', modal).forEach((btn) => btn.addEventListener('click', close));
  $$('[data-modal-prev]', modal).forEach((btn) => btn.addEventListener('click', () => render(index - 1)));
  $$('[data-modal-next]', modal).forEach((btn) => btn.addEventListener('click', () => render(index + 1)));

  // Click en el fondo (fuera del panel) cierra — igual que el onClick del overlay.
  modal.addEventListener('click', (e) => {
    if (!panel.contains(e.target)) close();
  });

  document.addEventListener('keydown', (e) => {
    if (!isOpen()) return;
    if (e.key === 'ArrowRight') render(index + 1);
    else if (e.key === 'ArrowLeft') render(index - 1);
    // Escape lo dispara <dialog> por sí solo; sólo hace falta cubrir el fallback.
    else if (e.key === 'Escape' && !supportsDialog) close();
  });

  // Escape y el cierre nativo terminan acá: limpiar después de cerrar.
  modal.addEventListener('close', cleanup);
}
